<template>
	<div class="col-md-12 col-lg-12 mb-3">
		{{anios}}
		{{anioActual}}
		<b-overlay :show="isOverlay" rounded="sm" spinner-variant="primary" class="h-100">
			<div class="card card-grafica" style="max-height:450px;overflow-y:auto">
				<div class="card-body">
					<div class="filtro-grafic" id="grafica_002" v-if="isVisible">
						<div class="row justify-content-start">
							<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<form class="form-inline">
									<label class="title-grafic side-l mr-3">Oportunidades</label>
									<label for="">Año</label>
									<select @change="GetDashboard" v-model="Anio" class="ml-2 form-control" id="">
										<option value="">Todos</option>
										<option v-for="(item,index) in pListaAnios" :key="index" :value="item">{{item}}</option>
									</select>

									<label class="ml-3">Mes</label>
									<select @change="GetDashboard()" v-model="Mes" class="ml-3 form-control form-control-sm">
										<option value="">Todos</option>
										<option value="1">Enero</option>
										<option value="2">Febrero</option>
										<option value="3">Marzo</option>
										<option value="4">Abril</option>
										<option value="5">Mayo</option>
										<option value="6">Junio</option>
										<option value="7">Julio</option>
										<option value="8">Agosto</option>
										<option value="9">Septiembre</option>
										<option value="10">Octubre</option>
										<option value="11">Noviembre</option>
										<option value="12">Diciembre</option>
									</select>
								</form>
								<button type="button" class="btn close abs_01" @click="ocultarfiltro()"><i class="fal fa-times"></i></button>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-10 col-sm-10 col-md-8 col-lg-8">
							<h6 class="title-grafic side-l">Oportunidades</h6>
						</div>
						<div class="col-2 col-sm-2 col-md-4 col-lg-4 text-right">
							<button	type="button" class="btn-fil-002" title="Filtros" @click="mostrarfiltro()">
								<i class="fas fa-filter"></i>
							</button>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<hr />
						</div>
					</div>
					<div class="row d-flex justify-content-center">
						<div class="col-lg-1">
							<div class="card">
								<div class="card-body ml-0 mr-0 pl-0 pr-0">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesNuevas }}</h1>
									<h4 class="text-center" style="color:#FF831B">Nuevas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-1">
							<div class="card">
								<div class="card-body ml-0 mr-0 pl-0 pr-0">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesCalificadas }}</h1>
									<h4 class="text-center" style="color:#FF831B">Calificadas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-1">
							<div class="card">
								<div class="card-body ml-0 mr-0 pl-0 pr-0">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesPropuestas }}</h1>
									<h4 class="text-center" style="color:#FF831B">Propuestas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-1">
							<div class="card">
								<div class="card-body ml-0 mr-0 pl-0 pr-0">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesSeguimiento }}</h1>
									<h4 class="text-center" style="color:#FF831B">Seguimiento</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-1">
							<div class="card">
								<div class="card-body ml-0 mr-0 pl-0 pr-0">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesGanadas }}</h1>
									<h4 class="text-center" style="color:#FF831B">Ganadas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-1">
							<div class="card">
								<div class="card-body ml-0 mr-0 pl-0 pr-0">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesCerradas }}</h1>
									<h4 class="text-center" style="color:#FF831B">Cerradas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-1">
							<div class="card">
								<div class="card-body ml-0 mr-0 pl-0 pr-0">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">{{ Contadores.ContadorOportunidadesPerdidas }}</h1>
									<h4 class="text-center" style="color:#FF831B">Perdidas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-2" style="flex-basis:13% !important">
							<div class="card">
								<div class="card-body">
									<h1 class="text-center text-info" style="font-size:48px; margin-bottom: 0.1em;">${{ formateoMillon(Number(Contadores.MontoOportunidadesCalificadas)) }}</h1>
									<h4 class="text-center" style="color:#FF831B">Monto Calificadas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-2" style="flex-basis:13% !important">
							<div class="card">
								<div class="card-body">
									<h1 class="text-center text-danger" style="font-size:48px; margin-bottom: 0.1em;">${{ formateoMillon(Number(Contadores.MontoOportunidadesPerdidas)) }}</h1>
									<h4 class="text-center" style="color:#FF831B">Monto Perdidas</h4>
								</div>
							</div>
						</div>
						<div class="col-lg-2" style="flex-basis:13% !important">
							<div class="card">
								<div class="card-body">
									<h1 class="text-center text-success" style="font-size:48px; margin-bottom: 0.1em;">${{ formateoMillon(Number(Contadores.MontoOportunidadesGanadas)) }}</h1>
									<h4 class="text-center" style="color:#FF831B">Monto Ganadas</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>
export default {
	name:'Oportunidades',
	props:['pListaAnios','pAnioActual'],
	data() {
		return {
			Mes:"",
			isOverlay:false,
            isVisible:false,
			Anio:new Date().getFullYear(),
			Contadores:{
				ContadorOportunidadesNuevas:0,
				ContadorOportunidadesCalificadas:0,
				ContadorOportunidadesPropuestas:0,
				ContadorOportunidadesSeguimiento:0,
				ContadorOportunidadesPerdidas:0,
				ContadorOportunidadesGanadas:0,
				ContadorOportunidadesCerradas:0,
				MontoOportunidadesCalificadas:0,
				MontoOportunidadesPerdidas:0,
				MontoOportunidadesGanadas:0
			}
		}
	},
	methods: {
		mostrarfiltro(){
            this.isVisible=true;
        },
        ocultarfiltro(){
            this.isVisible=false;
        },
		async GetDashboard(){
			this.isOverlay=true;
			await this.$http.get("oportunidades/contadores/get",
			{
				params:{
					Anio:this.Anio,
					Mes:this.Mes
				}
			}
			).then((res)=>{
				this.Contadores.ContadorOportunidadesNuevas=res.data.data.OportunidadesNuevas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				this.Contadores.ContadorOportunidadesCalificadas=res.data.data.OportunidadesCalificadas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				this.Contadores.ContadorOportunidadesPropuestas=res.data.data.OportunidadesPropuestas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				this.Contadores.ContadorOportunidadesGanadas=res.data.data.OportunidadesGanadas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				this.Contadores.ContadorOportunidadesPerdidas=res.data.data.OportunidadesPerdidas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				this.Contadores.ContadorOportunidadesSeguimiento=res.data.data.OportunidadesSeguimiento.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				this.Contadores.ContadorOportunidadesCerradas=res.data.data.OportunidadesCerradas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				if (res.data.data.MontoOportunidadesCalificadas==null ? this.Contadores.MontoOportunidadesCalificadas=0 : this.Contadores.MontoOportunidadesCalificadas=res.data.data.MontoOportunidadesCalificadas);
				if (res.data.data.MontoOportunidadesPerdidas==null ? this.Contadores.MontoOportunidadesPerdidas=0 : this.Contadores.MontoOportunidadesPerdidas=res.data.data.MontoOportunidadesPerdidas);
				if (res.data.data.MontoOportunidadesGanadas==null ? this.Contadores.MontoOportunidadesGanadas=0 : this.Contadores.MontoOportunidadesGanadas=res.data.data.MontoOportunidadesGanadas);
				// this.ConfigLoadContadores.ShowLoader=false;
			}).finally(()=>{
				this.isOverlay=false;
			})
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        }
	},
	created() {
		if(this.pListaAnios !== undefined){
			this.ListaAnios = this.pListaAnios;
		}

		if(this.pAnioActual !== undefined) {
			this.Anio = this.pAnioActual
		}
	},
	computed: {
		anios(){
			if(this.pListaAnios !== undefined){
				this.ListaAnios = this.pListaAnios;
			}
		},

		anioActual(){
			if(this.pAnioActual !== undefined) {
				this.Anio = this.pAnioActual

			}
		}
	}
}
</script>

<style>

</style>
